// @flow strict

import React, { type Node, useState } from 'react';
import clsx from 'clsx';

import ArrowIcon from '@material-ui/icons/KeyboardArrowDownOutlined';

import * as styles from './faq.module.less';

type FAQProps = {
  question: string,
  children: Node,
};

/**
 * FAQ element for blog posts.
 *
 * @param props - component props
 *
 * @returns {Node}
 */
export const FAQ = ({ question, children }: FAQProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleArrowIconClick = () => {
    setIsOpen((state) => !state);
  };

  return (
    <article className={styles.faq}>
      <div
        className={clsx(styles.faqQuestion, { [styles.isOpen]: isOpen })}
        onClick={handleArrowIconClick}
      >
        <h3 className={styles.faqQuestionText}>{question}</h3>
        <ArrowIcon
          className={clsx(styles.faqQuestionIcon, { [styles.isOpen]: isOpen })}
        />
      </div>
      {isOpen && <section className={styles.faqContent}>{children}</section>}
    </article>
  );
};
